<template>
  <v-card class="create-sor">
    <v-card-title>
      {{ $t('user.reset_password') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field outlined
                      :label="$t('signup.password')"
                      v-model="password"
                      :type="showSignupPassword ? 'text' : 'password'"
                      :append-icon="showSignupPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                      @click:append="showSignupPassword = !showSignupPassword"
                      :rules="passwordRules">
        </v-text-field>
        <v-text-field outlined
                      :label="$t('signup.re_enter_password')"
                      v-model="reEnterPassword"
                      :type="showSignupReEnterPassword ? 'text' : 'password'"
                      :append-icon="showSignupReEnterPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                      @click:append="showSignupReEnterPassword = !showSignupReEnterPassword"
                      :rules="reEnterPasswordRules">
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'ResetUserPasswordDialog',
  props: {
    userId: String,
  },
  setup(props, {root, emit}) {
    const password = ref(null);
    const passwordRules = ref([
      value => (!!value && value.length >= 8) || root.$t('signup.password_contain_eight_characters'),
      value => (!!value && !!value.match(/[A-Za-z]/g)) || root.$t('signup.password_contain_letters'),
      value => (!!value && !!value.match(/[0-9]/g)) || root.$t('signup.password_contain_numbers'),
      value => (!!value && !!value.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !value.match(/[ ]/g)) || root.$t('signup.password_contain_special_characters'),
    ]);
    const showSignupPassword = ref(false);
    const reEnterPassword = ref(null);
    const reEnterPasswordRules = ref([
      value => (!!value && value === password.value) || root.$t('signup.password_mismatch')
    ]);
    const showSignupReEnterPassword = ref(false);

    const save = async function () {
      if (await root.$dialog.confirm({text: root.$t('user.reset_password_confirm_msg'), showClose: false})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/user/reset_password/',
          params: {
            user_id: props.userId,
            password: password.value,
          },
        });

        if (response.body.success) {
          emit('submit', true);
        }
      }
    }

    return {
      password,
      passwordRules,
      showSignupPassword,
      reEnterPassword,
      reEnterPasswordRules,
      showSignupReEnterPassword,
      save,
    }
  },
}
</script>
